import {QuestionnaireCategorie} from './questionnaireCategorie';

export class Categorie {
  id: number;
  nom: string;
  questionnaireCategories: QuestionnaireCategorie[];
}
